import { Button, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutZipCodeGenerator extends Layout {
    buttonClear: Button;
    buttonGenerateZips: Button;
    tableGeneratedZipCodes: Table;
    textboxEffectiveTimestamp: Textbox;
    textboxEnding3Digits: Textbox;
    textboxExpireTimestamp: Textbox;
    textboxRegionCode: Textbox;
    textboxStarting3Digits: Textbox;
    textboxStateId: Textbox;
}
